"use strict";
/**
 * Created by Pankaj on 2019-12-26.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestMethod = void 0;
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["POST"] = "POST";
    RequestMethod["GET"] = "GET";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["HEAD"] = "HEAD";
})(RequestMethod = exports.RequestMethod || (exports.RequestMethod = {}));
//# sourceMappingURL=RequestMethod.js.map